<template>
  <jet-dialog-modal 
    :show="show" 
    @close="$emit('cancel')"
  >
    <template #title>
      {{ title }}
    </template>
    
    <template #content>
      <p class="text-sm text-gray-600">{{ message }}</p>
    </template>
    
    <template #footer>
      <jet-secondary-button @click="$emit('cancel')">
        {{ cancelText }}
      </jet-secondary-button>

      <jet-danger-button
        v-if="mode === 'danger'"
        class="ml-2"
        @click="$emit('confirm')"
      >
        {{ confirmText }}
      </jet-danger-button>

      <jet-button
        v-else
        class="ml-2"
        @click="$emit('confirm')"
      >
        {{ confirmText }}
      </jet-button>
    </template>
  </jet-dialog-modal>
</template>

<script setup>
import JetDialogModal from '@/Jetstream/DialogModal.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import JetDangerButton from '@/Jetstream/DangerButton.vue';
import JetButton from '@/Jetstream/Button.vue';

// NOTE: If you're reading this, window.Confirm is a global function that can be used to trigger the modal.

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Confirm'
  },
  message: {
    type: String,
    required: true
  },
  mode: {
    type: String,
    default: 'regular',
    validator: value => ['regular', 'danger'].includes(value)
  },
  confirmText: {
    type: String,
    default: 'Yes'
  },
  cancelText: {
    type: String,
    default: 'Cancel'
  }
});

const emit = defineEmits(['confirm', 'cancel']);
</script>